module.exports = __webpack_public_path__ + "static/harry-potter-and-the-philosophers-stone-a106d4b7ac989b1258d58caf7cdd46f3.jpg";